export default __webpack_public_path__ + "static/media/returnInvoiceCover.186aaeae.svg";